import { ChangeEvent, ReactNode } from 'react'
import _ from 'lodash'
import L1Select from '../l1/L1Select'
import { SuperconceptStatus } from '@fusion-advantage/backcompat'

interface L3SelectProps {
	conceptStatus: SuperconceptStatus|null,
	onChange: (e: ChangeEvent<HTMLSelectElement>) => void,
	children?: ReactNode,
	nullOption?: boolean,
}

const L3Select = ({conceptStatus, onChange, children, nullOption}: L3SelectProps) => {
	let value: string|null = null
	_.forEach(conceptStatus?.subconcepts, subconcept => {
		if(subconcept.value === true) {
			value = subconcept.cid
		}
	})
	return (
		<L1Select
			value={value}
			onChange={onChange}
			nullOption={nullOption}
		>
			{children}
		</L1Select>
	)
}

export default L3Select
